import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'

import Icon, { IconNames } from 'components/icons'
import { isEmpty } from 'helpers/utils'

import { Container, IconContainer, StyledNumber } from './styled'

const DEFAULT_VALUE = 0
const CONST = 1

class InputNumber extends Component {
  state = { selectedNumber: this.props.value || DEFAULT_VALUE }

  componentDidUpdate(prevProps) {
    // check !isNaN(this.props.value) prevents breaking page when returning with back button from search
    if (prevProps.value !== this.props.value && !isNaN(this.props.value)) {
      this.setState({ selectedNumber: this.props.value })
    }
  }

  handleChangePlus = () => {
    const INDEX_OFFSET = 1
    const { onChange, isPlusButtonDisabled, handleChangePlus, restrictions } = this.props

    if (isPlusButtonDisabled) {
      return
    }

    this.setState(
      ({ selectedNumber }) => ({
        selectedNumber:
          (!isEmpty(restrictions) &&
            restrictions[restrictions.indexOf(selectedNumber) + INDEX_OFFSET]) ||
          selectedNumber + CONST
      }),
      () => {
        onChange && onChange({ value: this.state.selectedNumber })
        handleChangePlus && handleChangePlus({ value: this.state.selectedNumber })
      }
    )
  }

  handleChangeMinus = () => {
    const INDEX_OFFSET = 1
    const { isMinusButtonDisabled, onChange, handleChangeMinus, restrictions } = this.props

    if (isMinusButtonDisabled) {
      return
    }

    this.setState(
      ({ selectedNumber }) => ({
        selectedNumber:
          (!isEmpty(restrictions) &&
            restrictions[restrictions.indexOf(selectedNumber) - INDEX_OFFSET]) ||
          selectedNumber - CONST
      }),
      () => {
        onChange && onChange({ value: this.state.selectedNumber })
        handleChangeMinus && handleChangeMinus({ value: this.state.selectedNumber })
      }
    )
  }

  render() {
    const { id, isPlusButtonDisabled, isMinusButtonDisabled } = this.props
    const { selectedNumber } = this.state
    const { t } = this.props

    return (
      <Container>
        <IconContainer
          e2eClass={`remove-${id}`}
          onClick={() => this.handleChangeMinus()}
          disabled={isMinusButtonDisabled}
          aria-label={t('alt.minus-btn')}
        >
          <Icon name={IconNames.Minus} size={16} />
        </IconContainer>
        <StyledNumber
          e2eClass={`input-value-${id}`}
          value={selectedNumber}
          defaultValue={DEFAULT_VALUE}
        >
          {selectedNumber}
        </StyledNumber>
        <IconContainer
          e2eClass={`add-${id}`}
          onClick={() => this.handleChangePlus()}
          disabled={isPlusButtonDisabled}
          aria-label={t('alt.plus-btn')}
        >
          <Icon name={IconNames.Plus} size={16} />
        </IconContainer>
      </Container>
    )
  }
}

export default withTranslation()(InputNumber)
